import { render, staticRenderFns } from "./Broadcast.vue?vue&type=template&id=78af1212&scoped=true&"
import script from "./Broadcast.vue?vue&type=script&lang=ts&"
export * from "./Broadcast.vue?vue&type=script&lang=ts&"
import style0 from "./Broadcast.vue?vue&type=style&index=0&id=78af1212&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78af1212",
  null
  
)

export default component.exports